import { render, staticRenderFns } from "./PerformSwiperComponent.vue?vue&type=template&id=1cf3d1ba&scoped=true&"
import script from "./PerformSwiperComponent.vue?vue&type=script&lang=js&"
export * from "./PerformSwiperComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf3d1ba",
  null
  
)

export default component.exports